import { Helmet } from 'react-helmet'
import TypingEffect from './TypingEffect'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Typing Effect</title>
    </Helmet>
    <TypingEffect />
  </>
)
export default Wrapper
